import nextSvg from '../../../assets/svg/angle-right.svg';
import prevSvg from '../../../assets/svg/angle-left.svg'

export default Array.from( document.querySelectorAll( '.credit-slider' ) ).map( ( feeds ) => {
	const wrap   = feeds.querySelector('.credit-slider__wrap');
	const items  = feeds.querySelector('.credit-slider__items');
	const slides = Array.from( feeds.querySelectorAll('.credit-slide') );
	wrap.classList.add('swiper-container');
	items.classList.add('swiper-wrapper');
	slides.forEach(feed => feed.classList.add('swiper-slide'));
    if (slides.length) {
        feeds.insertAdjacentHTML(
            'beforeend',
           
               ` <div class="swiper-button-prev">${prevSvg}</div>
                <div class="swiper-button-next">${nextSvg}</div>`
           
        );
    }
	return new window.Swiper( wrap, {
		direction: 'horizontal',
		// effect: 'fade',
		autoHeight: false,
		speed: 600,
		spaceBetween: 30,
        slidesPerView: 4,
        observer: true,
        observeParents: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        watchOverflow: true,
		navigation: {
			prevEl: '.swiper-button-prev',
			nextEl: '.swiper-button-next',
		},
		pagination: false,
        breakpoints: {
            480: {
                slidesPerView: 1,
            },
            700: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            }
        },
	} );
} );